import { Select, Button, Form } from "antd";
import { FORMS, BUTTONS } from "../common/constants";

const CreateFleetVehicleForm = ({ vehicleList, fleetVehicleImei, isBtnLoader, handleSubmit }) => {

  const getFormFieldRule = (field) => [
    {
      required: true,
      message: `Please Enter ${field}!`,
    },
  ];

  return (
    <Form
      name="addVehicleForm"
      onFinish={handleSubmit}
      autoComplete="off"
      className="mt2"
      initialValues={{
        [FORMS.FLEETS.VEHICLE.FIELDS.IMEI.NAME]: fleetVehicleImei
      }}
    >
      <Form.Item
        name={FORMS.FLEETS.VEHICLE.FIELDS.IMEI.NAME}
        label={FORMS.FLEETS.VEHICLE.FIELDS.IMEI.LABEL}
        rules={getFormFieldRule(FORMS.FLEETS.VEHICLE.FIELDS.IMEI.LABEL)}
      >
        <Select
          allowClear
          mode="multiple"
          maxTagCount={"responsive"}
          placeholder={FORMS.FLEETS.VEHICLE.FIELDS.IMEI.PLACEHOLDER}
          options={vehicleList}
          fieldNames={{
            label: "vehImei",
            value: "vehImei",
            options: "options",
          }}
        />
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={isBtnLoader}>
        {BUTTONS.MODIFY}
      </Button>
    </Form>
  );
};

export default CreateFleetVehicleForm;
